import PaystackPop from "@paystack/inline-js";
import { axiosget, axiospost } from "./httprequest";
import swal from "./swal";

export const paymentHandler = (email, amount, meta, to, publicKey) => {
  const paystackKey = publicKey || import.meta.env.VITE_PAYSTACK_PUBLIC_KEY || "pk_test_cbde3c75ddff2292f6cc66cf0041c9cdf91af96f";
  const handle = PaystackPop.setup({
    key: paystackKey,
    email,
    amount: amount * 100,
    currency: "NGN",
    metadata: meta,
    callback: async (response) => {
      const reference = response.reference;
      const req = await axiosget(`ms_transaction/verify-new/${reference}`);
      if (req.status !== 200) {
        swal(
          "info",
          `Sorry your transaction was successfull, but could not be stored, Please copy this transaction code ${reference} as we will request for it`,
          undefined,
          false
        );
        return;
      }
      const { type, message } = req.data;
      if (type === "success") {
        swal(type, message, () => (window.location.href = to), false);
        return;
      }
      swal(type, message, undefined, false);
      return;
    },
    onClose: function () {
      swal(
        "info",
        "Transaction was not completed, window closed.",
        undefined,
        false
      );
    },
  });

  handle.openIframe();
};

export const walletHandler = (email, amount, meta, publicKey) => {
  const paystackKey = publicKey || import.meta.env.VITE_PAYSTACK_PUBLIC_KEY || "pk_test_cbde3c75ddff2292f6cc66cf0041c9cdf91af96f";
  const handle = PaystackPop.setup({
    key: paystackKey,
    email,
    amount: amount * 100,
    currency: "NGN",
    metadata: meta,
    callback: async (response) => {
      const reference = response.reference;
      const req = await axiosget(
        `ms_student_wallet_transactions/verify-funding/${reference}`
      );
      if (req.status !== 200) {
        swal(
          "info",
          `Sorry your transaction was successfull, but could not be stored, Please copy this transaction code ${reference} as we will request for it`,
          undefined,
          false
        );
        return;
      }
      const { type, message } = req.data;
      if (type === "success") {
        swal(type, message, () => window.location.reload(), false);
        return;
      }
      swal(type, message, undefined, false);
      return;
    },
    onClose: function () {
      swal(
        "info",
        "Transaction was not completed, window closed.",
        undefined,
        false
      );
    },
  });

  handle.openIframe();
};

export const fundWalletHandler = async (amount, studentInfo, onSuccess) => {
  try {
    // 1. Initiate Funding on Backend
    const initReq = await axiospost("ms_student_wallet_transactions/initiate-funding", {
      amount,
      // Gateway is now determined by backend default, or could be passed if selected
    });

    if (initReq.data.type === "error") {
      swal("error", initReq.data.message);
      return;
    }

    // 2. Open payment URL in new tab so student can complete payment
    if (initReq.data.type === "success") {
      const { paymentUrl } = initReq.data;
      if (paymentUrl) {
        window.open(paymentUrl, "_blank");
      }
      swal("info", "A payment page has been opened in a new tab. Complete payment there, then return here and click Verify.");
      if (onSuccess) onSuccess();
    } else {
      swal("error", initReq.data.message || "Failed to initiate transaction");
    }

  } catch (error) {
    console.error(error);
    swal("error", "Unable to initiate payment. Please try again.");
  }
};
